import React from "react";
import img82 from "../assests/IMG_4924.jpeg";
import img100 from "../assests/IMG_2616.jpeg";
import img79 from "../assests/QAC 1ST LADY.jpeg";
import img105 from "../assests/FAQ.jpeg";
import img106 from "../assests/GIMG.jpeg";
import img1 from "../assests/QIMG2.jpeg";
import img2 from "../assests/IMG_6848.jpeg";
import img3 from "../assests/IMG_7566.jpeg";
import img4 from "../assests/IMG_6790.jpeg";
import img5 from "../assests/qac24.jpeg";
import img6 from "../assests/QW7.jpeg";
import img7 from "../assests/C1.jpeg";
import img8 from "../assests/d1d3745d-1b38-4220-aa79-5c6de9c40d5f.jpeg";
import img9 from "../assests/db35cfb9-0b1c-45ea-9603-257f0eea058a.jpeg";
import img10 from "../assests/DEPCHAIR.jpeg";
import img11 from "../assests/GIMG5.jpeg";
import img12 from "../assests/GIMG14.jpeg";
import img13 from "../assests/GIMG13.jpeg";
import img14 from "../assests/qac11.jpg";
import img15 from "../assests/qac13.jpg";
import img16 from "../assests/IMG_8479.jpeg";
import img17 from "../assests/qac17.jpg";
import img18 from "../assests/qac14.jpg";
import img19 from "../assests/qac7.jpg";
import img20 from "../assests/qac8.jpg";
import img21 from "../assests/qac23.jpeg";
import img22 from "../assests/qac16.jpg";
import img23 from "../assests/register.jpeg";
import img24 from "../assests/IMG_3698.jpeg";
import img25 from "../assests/IMG_2236.jpeg";
import img26 from "../assests/IMG_2337.jpeg";
import img27 from "../assests/CHRISTMAS.jpeg";
import img28 from "../assests/qac15.jpg";
import img29 from "../assests/QIMG1.jpeg";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

//THIS IS EMBLA CAROUSAL

const Carousel = () => {
  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    autoplay: true,
    speed: 500,
    autoplaySpeed: 2000,
    fade: true,
    cssEase: "linear",
    adaptiveHeight: false,
    nextArrow: false,
    prevArrow: false,
    arrows: false,
  };
  return (
    <div className="h-full w-full bg-[#001ea1] py-10 md:px-56 rounded-2xl items-center justify-center">
      <div className="rounded-2xl shadow-2xl shadow-black md:px-10 h-full w-full pt-16 items-center justify-center">
        <Slider {...settings}>
          <div className="card  object-contain object-center">
            <img src={img82} alt="" />
          </div>
          <div className="card object-contain object-top">
            <img src={img100} alt="" />
          </div>
          <div className="card object-contain object-top">
            <img src={img79} alt="" />
          </div>
          <div className="card object-contain object-top">
            <img src={img105} alt="" />
          </div>
          <div className="card object-contain object-top">
            <img src={img106} alt="" />
          </div>
          <div className="card object-contain object-top">
            <img src={img1} alt="" />
          </div>
          <div className="card object-contain object-top">
            <img src={img2} alt="" />
          </div>
          <div className="card object-contain object-top">
            <img src={img3} alt="" />
          </div>{" "}
          <div className="card object-contain object-top">
            <img src={img4} alt="" />
          </div>{" "}
          <div className="card object-contain object-top">
            <img src={img5} alt="" />
          </div>{" "}
          <div className="card object-contain object-top">
            <img src={img6} alt="" />
          </div>{" "}
          <div className="card object-contain object-top">
            <img src={img7} alt="" />
          </div>{" "}
          <div className="card object-contain object-top">
            <img src={img8} alt="" />
          </div>{" "}
          <div className="card object-contain object-top">
            <img src={img9} alt="" />
          </div>{" "}
          <div className="card object-contain object-top">
            <img src={img10} alt="" />
          </div>{" "}
          <div className="card object-contain object-top">
            <img src={img11} alt="" />
          </div>
          <div className="card object-contain object-top">
            <img src={img12} alt="" />
          </div>{" "}
          <div className="card object-contain object-top">
            <img src={img13} alt="" />
          </div>{" "}
          <div className="card object-contain object-top">
            <img src={img14} alt="" />
          </div>{" "}
          <div className="card object-contain object-top">
            <img src={img15} alt="" />
          </div>{" "}
          <div className="card object-contain object-top">
            <img src={img16} alt="" />
          </div>{" "}
          <div className="card object-contain object-top">
            <img src={img17} alt="" />
          </div>{" "}
          <div className="card object-contain object-top">
            <img src={img18} alt="" />
          </div>{" "}
          <div className="card object-contain object-top">
            <img src={img19} alt="" />
          </div>
          <div className="card object-contain object-top">
            <img src={img20} alt="" />
          </div>
          <div className="card object-contain object-top">
            <img src={img21} alt="" />
          </div>
          <div className="card object-contain object-top">
            <img src={img22} alt="" />
          </div>
          <div className="card object-contain object-top">
            <img src={img23} alt="" />
          </div>
          <div className="card object-contain object-top">
            <img src={img24} alt="" />
          </div>
          <div className="card object-contain object-top">
            <img src={img25} alt="" />
          </div>
          <div className="card object-contain object-top">
            <img src={img26} alt="" />
          </div>
          <div className="card object-contain object-top">
            <img src={img27} alt="" />
          </div>
          <div className="card object-contain object-top">
            <img src={img28} alt="" />
          </div>
          <div className="card object-contain object-top">
            <img src={img29} alt="" />
          </div>
        </Slider>
      </div>
    </div>
  );
};

export default Carousel;
